import { hlStudentList, studentList, updateCheckedStudent, getStudentInfo, updateStudentInfo, addStudentInfo, smsCodeStudent, smsCodeCheckStudent, getGradeList, confirmInfo, addHlStudent } from '@/api/mine/mine';

const student = {
  state: {
    gradeList: [],
    checkStudentList: []
  },

  mutations: {
    SET_GRADE_LIST: (state, data) => {
      state.gradeList = data;
    },
    CHECK_STUDENT_LIST: (state, data) => {
      state.checkStudentList = data;
    }
  },

  actions: {
    // 前台海亮学生列表
    hlStudentList({ commit }, data) {
      return new Promise((resolve, reject) => {
        hlStudentList(data).then(res => {
          console.log('res', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 学生列表
    studentList({ commit }, data) {
      return new Promise((resolve, reject) => {
        studentList(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 设置为默认学生
    updateCheckedStudent({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateCheckedStudent(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取账户学生详细信息
    getStudentInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getStudentInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改学生账户学生详细信息
    updateStudentInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateStudentInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 新增学生
    addStudentInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        addStudentInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    smsCodeStudent({ commit }, data) {
      return new Promise((resolve, reject) => {
        smsCodeStudent(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 检测返回学生列表
    smsCodeCheckStudent({ commit }, data) {
      return new Promise((resolve, reject) => {
        smsCodeCheckStudent(data).then(res => {
          commit('CHECK_STUDENT_LIST', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取年级列表
    getGradeList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getGradeList(data).then(res => {
          if (res.data && res.data.rows) {
            commit('SET_GRADE_LIST', res.data.rows);
          } else {
            commit('SET_GRADE_LIST', []);
          }

          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 注册后海亮学生绑定确认信息
    confirmInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        confirmInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 认证绑定或覆盖海亮学生
    addHlStudent({ commit }, data) {
      return new Promise((resolve, reject) => {
        addHlStudent(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default student;



// WEBPACK FOOTER //
// ./src/store/student.js